import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import GetPastDrafts from "../components/GetPastDrafts";

export default function SnapDraftHome({ user }) {
  const navigate = useNavigate();
  const [joinId, setJoinId] = useState("");

  const handleCreateRoom = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}api/draft/room/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: user.id }),
      });

      if (!res.ok) throw new Error("Failed to create room");
      const data = await res.json();
      navigate(`/draft/room/${data.roomId}`);
    } catch (err) {
      console.error("Error creating draft room:", err);
      alert("Failed to create room. Check console for details.");
    }
  };

  const handleJoinRoom = async () => {
    if (!joinId.trim()) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}api/draft/room/${joinId.trim()}/join`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: user.id }),
      });

      if (!res.ok) {
        const data = await res.json();
        alert(data.error || "Failed to join room");
        return;
      }

      navigate(`/draft/room/${joinId.trim()}`);
    } catch (err) {
      console.error("Error joining room:", err);
      alert("Failed to join room. Check console for details.");
    }
  };

  return (
    <div className="drafts-panel">
      <h1 className="drafts-heading">Snap Draft</h1>

      <div className="drafts-controls dual-columns">
        {/* Start New Draft */}
        <div className="draft-column">
          <h2 className="results-heading">Start a New Draft</h2>
          <button className="modern-btn" onClick={handleCreateRoom}>
            Create Draft Room
          </button>
        </div>

        {/* Join Draft Room */}
        <div className="draft-column">
          <h2 className="results-heading">Join Draft Room</h2>
          <div className="join-inline">
            <input
              className="modern-input"
              type="text"
              placeholder="Enter Room ID"
              value={joinId}
              onChange={(e) => setJoinId(e.target.value)}
            />
            <button className="modern-btn" onClick={handleJoinRoom}>
              Join
            </button>
          </div>
        </div>
      </div>

      <div className="drafts-divider" />

      <GetPastDrafts />
    </div>
  );
}
